/**
 * File simplemodal.js.
 *
 * Handles the modal for ADA notification
 */

//= require jquery.popupoverlay.js

'use strict';

// Define our "twinpines" object, if not already defined
if ( twinpines === undefined ) {
	var twinpines = {};
}

twinpines.modal = ( function( $ ) {

	var
		$ada = $( '#ada' ),

		init = function() {

			$ada.popup({
				closebutton: true,
			});
			$.fn.popup.defaults.pagecontainer = '#page';
		};

	return {
		init : init
	};

}( jQuery ) );


(function() {
	twinpines.modal.init();
}());
